/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React, { useState } from 'react'
import AutoSuggestionsdataSearch from '../../Components/Movie/movieSearchAutosuggestion'
function AutoSuggestionInputCrew(props) {
  const {
    setDisableUpdateButton,
    typeValue,
    listData,
    setListData,
    dynamicListInfo,
    setCrewSelectedArryTocheckAndOrConditon,
  } = props
  const [onSelectSuggestionDisplayNone, setonSelectSuggestionDisplayNone] = useState(false)
  const [CrewArraySelectedNames, setCrewArraySelectedNames] = useState([])
  const [AutoSuggetions, setAutoSuggetions] = useState([])
  const [selectedCastData, setSelectedCastData] = useState([listData && listData[typeValue]])
  const [SearchPerson, setSearchPerson] = useState('')
  const selectedCrew = [...selectedCastData, ...[listData && listData[typeValue]]]
  let array2 = []
  selectedCrew.map(item => {
    if (Array.isArray(item)) {
      item.map(value => array2.push(value))
    } else {
      array2.push(item)
    }
  })

  array2 = array2.filter((item, index) => array2.indexOf(item) === index)
  array2 = array2.filter(item => item !== undefined)

  // selectedCrew = selectedCrew.map(item)
  const handleSearchInput = async e => {
    setDisableUpdateButton(false)
    setCrewArraySelectedNames(array2)
    setSearchPerson(e.target.value)
    if (e.target.value.length > 3) {
      setonSelectSuggestionDisplayNone(true)
      const input = {
        search: e.target.value,
        type: 'person',
        limit: 10,
        from: 0,
      }
      const autoSuggestions = await AutoSuggestionsdataSearch(input)
      const listoptions = autoSuggestions.personHits.map(item => item.name_En)
      setAutoSuggetions(listoptions)
    } else {
      setonSelectSuggestionDisplayNone(false)
    }
  }

  function selectSuggestionlist(e) {
    // props.setCrewProfectionlName(props.crewName)
    setDisableUpdateButton(false)
    array2.push(e.target.getAttribute('value'))

    setSelectedCastData(array2)
    // props.setCrewOrcastData(array2)
    const selectedModifiedArray = []
    if (array2.length > 0) {
      if (typeValue === 'cast_En') {
        dynamicListInfo.castFilterBy = props.conditionOrAnd
      } else {
        dynamicListInfo.crewFilterBy = props.conditionOrAnd
      }

      array2.map(item => {
        if (item.length === 0) {
          return ''
        }

        selectedModifiedArray.push(item)

        return selectedModifiedArray
      })

      setCrewSelectedArryTocheckAndOrConditon(selectedModifiedArray)
      dynamicListInfo[typeValue] = selectedModifiedArray
    } else {
      delete dynamicListInfo[typeValue]
      if (typeValue === 'cast_En' && selectedModifiedArray.length === 0) {
        delete dynamicListInfo.castFilterBy
      } else {
        // delete dynamicListInfo.crewFilterBy
      }
    }

    // props.PersonCrewFilter(array2, props.crewName, 'crewFilterBy', conditionForCrewFilter)
    setonSelectSuggestionDisplayNone(false)
    setSearchPerson(e.target.getAttribute('value'))
    setAutoSuggetions(AutoSuggetions.filter(item => !array2.includes(item)))
    setCrewArraySelectedNames(array2)

    setSearchPerson('')
    const listDataTemp = { ...listData }
    listDataTemp[typeValue] = array2.flat(1)
    setListData(listDataTemp)
  }

  const closeAutoSuggestion = () => {
    setonSelectSuggestionDisplayNone(!onSelectSuggestionDisplayNone)
  }

  const handleInputBox = () => {
    // setshowConditionUi(false)
  }

  const handleRemoveName = data => {
    setDisableUpdateButton(false)
    // props.setCrewProfectionlName(props.crewName)

    const selectedArray = array2.filter(item => item !== data)
    const selectedModifiedArrayinRemove = []
    selectedArray.map(item => {
      if (item.length === 0) {
        return ''
      }

      selectedModifiedArrayinRemove.push(item)

      return selectedModifiedArrayinRemove
    })

    // props.setCrewOrcastData(selectedArray)
    setCrewSelectedArryTocheckAndOrConditon(selectedModifiedArrayinRemove)
    dynamicListInfo[typeValue] = selectedModifiedArrayinRemove
    if (selectedModifiedArrayinRemove.length === 0) {
      delete dynamicListInfo[typeValue]
    }

    // props.PersonCrewFilter(selectedArray, props.crewName, 'crewFilterBy', conditionForCrewFilter)
    setCrewArraySelectedNames(array2)

    setSelectedCastData(selectedArray)
    AutoSuggetions.push(data)
    setAutoSuggetions(AutoSuggetions)
    const listDataTemp = { ...listData }
    listDataTemp[typeValue] = selectedArray.flat(1)
    setListData(listDataTemp)
  }

  return (
    <div className='d-flex flex-column'>
      {array2.length > 0 ? (
        <span className='inputBox p-1 d-flex flex-wrap gap-2'>
          {listData &&
            listData[typeValue] &&
            listData[typeValue].map((item, index) => (
              <span
                key={index}
                style={{ width: 'max-content' }}
                className='cursor-pointer	border align-items-center border-dark mr-1 rounded px-1 '
              >
                {item}
                <span className='m-2' onClick={() => handleRemoveName(item)}>
                  X
                </span>
              </span>
            ))}
        </span>
      ) : null}

      <div className='d-flex flex-column' onClick={closeAutoSuggestion}>
        <div onClick={handleInputBox}>
          <input
            className='w-100'
            // disabled={props.statusType === 'draft'}
            name='search'
            value={SearchPerson}
            type='text'
            onChange={handleSearchInput}
          ></input>
        </div>
      </div>
      <div
        style={{
          border: ' 1px solid gray',
          borderRadius: '0px 0px 6px 6px',
          cursor: 'pointer',
        }}
      >
        {SearchPerson.length > 3
          ? onSelectSuggestionDisplayNone
            ? AutoSuggetions.length === 0
              ? 'No Data Found'
              : AutoSuggetions.map((item, index) => (
                  <div style={{ padding: '2px' }} key={index} className='w-100'>
                    <lable value={item} onClick={selectSuggestionlist} key={index}>
                      {item}
                    </lable>
                  </div>
                ))
            : null
          : null}
      </div>
    </div>
  )
}

export default AutoSuggestionInputCrew
